import common from './cloudTheme/commonStyle.oci';
import landscape from './cloudTheme/landscape.oci';
import portrait from './cloudTheme/portrait.oci';

export let commonStyles = common;
export let landscapeStyle = landscape;
export let portraitStyles = portrait;
